const parseQueryString = search => {
	if (!search) return {};

	search = search.substring(1);
	const parts = search.split('&');

	return parts.reduce((accum, part) => {
		if (!part) return accum;

		const pair = part.split('=');
		accum[decodeURIComponent(pair[0])] = pair[1] ? decodeURIComponent(pair[1]) : true;
		return accum;
	}, {});
};

export default parseQueryString;



// WEBPACK FOOTER //
// ./src/parseQueryString.js